import React from "react";
import { Link } from "react-router-dom";
import Image from "../../../elements/Image";
import Noimage from "../../../../assets/images/no-image-available.png";
import { classNames } from "../../../../helpers/classNames";

const EventItem = ({ data }) => {
  return (
    <>
      <Link
        to={data?.link}
        className="relative block space-y-6 bg-white py-4 px-4 rounded-xl shadow-lg"
      >
        <div className="w-full overflow-hidden aspect-[7/5] bg-shades-03">
          <Image
            src={data?.image || Noimage}
            alt={""}
            effect="blur"
            classes={classNames(
              !data?.image ? "object-contain scale-[0.8]" : "object-cover"
            )}
          />
        </div>
        <div className="flex items-center gap-10">
          {data?.postedBy && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-circle-user text-base xls:text-lg"></i>{" "}
              By {data?.postedBy}
            </div>
          )}
          {data?.date && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-calendars text-base xls:text-lg"></i>{" "}
              {data?.date}
            </div>
          )}
          {data?.time && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-clock text-base xls:text-lg text-chestnut-rose"></i>{" "}
              {data?.time}
            </div>
          )}
        </div>
        <div className="space-y-8 pb-8">
          {data?.title && <h2 className="text-xl font-bold">{data?.title}</h2>}
        </div>
      </Link>
    </>
  );
};

export default EventItem;
